<template>
  <div>
    <!-- content -->
    <v-row>
      <div
        v-for="(lesson, i) in items.content"
        :key="i"
        style="padding: 12px; width: 378px;"
      >
        <LessonCard :lesson="lesson" />
      </div>
    </v-row>
    <!-- pagination -->
    <v-row class="roma-pagination d-flex  align-center justify-end">
       <v-pagination
        color="#743085"
        v-model="pageCurrent"
        :length="dpTotalPages"
        total-visible="5"
      />
     </v-row>
  </div>
</template>

<script>
import LessonCard from "@/components/lesson/RomaLessonCard.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  props: ["items"],
  data() {
    return {
      circle: true,
      disabled: false,
      firstLoadDone: false,
      length: 10,
      page: 1,
      totalVisible: 8,
      tab: null,
      col: 3,
      pageCurrent: 1,
      pageLabel: "1",
      disableNext: false,
      disablePrev: true,
    };
  },
  components: {
    LessonCard
  },
  watch: {
    pageCurrent: {
        immediate: true,
        handler(value) {
          if(this.firstLoadDone){
            this.change();
          }else{
            this.firstLoadDone = true;
          }
        }
    },
  },
  computed: {
    getContent() {
      return this.items.content ? this.items.content : [];
    },
    ...mapGetters({
      drawer: "getDrawer",
      lessonFilter: "getLessonFilterInformation",
    }),
    gridLesson() {
      return this.$store.getters.getGridColumnLesson;
    },
    getCols() {
      let cols = "3";
      if (this.drawer === false) {
        cols = "4";
      }
      return cols;
    },
    dpTotalPages() {
      return this.items.totalPages;
    },
  },
  mounted() {
    this.totalPages = this.items.totalPages;
    // this.actionGetLessons({ pageNumber: 0, pageSize: 8 });
  },
  methods: {
    ...mapActions({
      actionGetLessons: "actionGetLessons",
    }),
    change() {
      const page = this.pageCurrent < 0 ? 0 : this.pageCurrent - 1;
      console.log('Página', this.pageCurrent);
      this.actionGetLessons({ pageNumber: page, pageSize: 8 });
      this.disableNext = this.pageCurrent >= this.totalPages - 1;
      this.disablePrev = this.pageCurrent <= 0;
    },
    next() {
      this.pageCurrent += 1;
      this.pageCurrent =
        this.pageCurrent >= this.totalPages - 1
          ? this.totalPages - 1
          : this.pageCurrent;
      this.actionGetLessons({
        pageNumber: this.pageCurrent,
        pageSize: 8,
      });
      this.disableNext = this.pageCurrent >= this.totalPages - 1;
      this.disablePrev = this.pageCurrent < 0;
    },
    previous() {
      this.pageCurrent -= 1;
      this.pageCurrent = this.pageCurrent <= 0 ? 0 : this.pageCurrent;
      this.actionGetLessons({
        pageNumber: this.pageCurrent,
        pageSize: 8,
      });
      this.disablePrev = this.pageCurrent <= 0;
      this.disableNext = this.pageCurrent >= this.totalPages - 1;
    },
    numberPages() {
      const pages = [];
      for (let index = 0; index < this.totalPages; index++) {
        pages.push({ index: index, label: index + 1 });
      }
      return pages;
    },
  },
};
</script>

<style lang="scss">
@import '../../assets/styles/generals.scss';
.roma-pagination {
  .wrapper {
    display: flex;
    .select-pagination {
      max-width: 100px;
      .v-text-field__details {
        display: none;
      }
    }
  }
}
</style>
